import { render, staticRenderFns } from "./alipay_app.vue?vue&type=template&id=84216214&scoped=true"
import script from "./alipay_app.vue?vue&type=script&lang=js"
export * from "./alipay_app.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84216214",
  null
  
)

export default component.exports